import { render, staticRenderFns } from "./ContactInsightWidget.vue?vue&type=template&id=5d345859&scoped=true"
import script from "./ContactInsightWidget.vue?vue&type=script&lang=js"
export * from "./ContactInsightWidget.vue?vue&type=script&lang=js"
import style0 from "./ContactInsightWidget.vue?vue&type=style&index=0&id=5d345859&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d345859",
  null
  
)

export default component.exports